import React, { useState } from "react";
import "./attendeeForm.css";

const AttendeeForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
  });

  const [status, setStatus] = useState(null); // null | "loading" | "success" | "error"

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch("/api/attendee-subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error("Failed");

      setStatus("success");
      window.location.href = "https://www.bizbazevents.com/thank-you";
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="attendee-wrap">
      <div className="attendee-inner">

        <div className="attendee-header">
          <span className="attendee-eyebrow">Join us at BizBaz</span>
          <h1 className="attendee-title">Get Event Updates</h1>
          <p className="attendee-subtitle">
            Pop in your name and email and we'll keep you posted
          </p>
        </div>

        <form onSubmit={handleSubmit} className="aweber-form">
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Your full name"
              required
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="you@example.com"
              required
            />
          </div>

          <button type="submit" className="submit-btn" disabled={status === "loading"}>
            {status === "loading" ? "Submitting..." : "Sign Up"}
          </button>

          {status === "error" && (
            <p className="form-error">
              Something went wrong. Please try again or contact us directly.
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default AttendeeForm;